var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { WebPlugin, Capacitor, Plugins } from "@capacitor/core";
import { decryptKey, decryptMessage, encryptKey, encryptMessage, generateKeyPair, generateSecretKey, generateSecureIV, generateSHA256 } from "./e2ee";
export class Media4CarePluginWeb extends WebPlugin {
    constructor() {
        super({
            name: "Media4CarePlugin",
            platforms: ["web"],
        });
        this.plugin = Plugins.Media4CarePlugin;
        this.isAndroid = Capacitor.platform === "android";
    }
    copyFromSdCard() {
        if (this.isAndroid)
            return this.plugin.copyFromSdCard();
        this.throwNotImplementedError();
    }
    getStorageDevices() {
        if (this.isAndroid)
            return this.plugin.getStorageDevices();
        this.throwNotImplementedError();
    }
    getTempThumbnail(options) {
        if (this.isAndroid)
            return this.plugin.getTempThumbnail(options);
        this.throwNotImplementedError();
    }
    getVideoThumbnail(options) {
        if (Capacitor.isNative)
            return this.plugin.getVideoThumbnail(options);
        throw new Error("Method not implemented.");
    }
    uploadFile(options) {
        if (Capacitor.isNative)
            return this.plugin.uploadFile(options);
        this.throwNotImplementedError();
    }
    downloadFile(options) {
        if (Capacitor.platform === "ios")
            return this.plugin.downloadFile(options);
        this.throwNotImplementedError();
    }
    compressVideo(options) {
        if (this.isAndroid)
            return this.plugin.compressVideo(options);
        this.throwNotImplementedError();
    }
    selectMedia(options) {
        if (Capacitor.isNative)
            return this.plugin.selectMedia(options);
        this.throwNotImplementedError();
    }
    throwNotImplementedError() {
        throw new Error(`method is not implemented for platform: ${Capacitor.platform}`);
    }
    setSegmentUser(options) {
        if (Capacitor.isNative)
            return this.plugin.setSegmentUser(options);
        this.throwNotImplementedError();
    }
    trackEvent(options) {
        if (Capacitor.isNative)
            return this.plugin.trackEvent(options);
        this.throwNotImplementedError();
    }
    trackScreen(options) {
        if (Capacitor.isNative)
            return this.plugin.trackScreen(options);
        this.throwNotImplementedError();
    }
    getBatteryOptimizations() {
        if (this.isAndroid)
            return this.plugin.getBatteryOptimizations();
        this.throwNotImplementedError();
    }
    requestIgnoreBatteryOptimizations() {
        if (this.isAndroid)
            return this.plugin.requestIgnoreBatteryOptimizations();
        this.throwNotImplementedError();
    }
    openBatteryOptimizationSettings() {
        if (this.isAndroid)
            return this.plugin.openBatteryOptimizationSettings();
        this.throwNotImplementedError();
    }
    getSerialNumber() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isAndroid) {
                return this.plugin.getSerialNumber();
            }
            else if (Capacitor.platform === "ios") {
                this.throwNotImplementedError();
            }
            return { serialNumber: "Web" };
        });
    }
    getIccId() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isAndroid) {
                return this.plugin.getIccId();
            }
            else if (Capacitor.platform === "ios") {
                this.throwNotImplementedError();
            }
            return { iccId: "Web" };
        });
    }
    setIdleTimerDisabled(options) {
        return __awaiter(this, void 0, void 0, function* () {
            if (Capacitor.platform === "ios") {
                return this.plugin.setIdleTimerDisabled(options);
            }
            else if (this.isAndroid) {
                this.throwNotImplementedError();
            }
        });
    }
    startCatapush(options) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isAndroid)
                return yield this.plugin.startCatapush(options);
            this.throwNotImplementedError();
        });
    }
    enableCatapushNotifications() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isAndroid)
                return this.plugin.enableCatapushNotifications();
            this.throwNotImplementedError();
        });
    }
    disableCatapushNotifications() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isAndroid)
                return this.plugin.disableCatapushNotifications();
            this.throwNotImplementedError();
        });
    }
    removeAllDeliveredNotifications() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isAndroid)
                return this.plugin.removeAllDeliveredNotifications();
            this.throwNotImplementedError();
        });
    }
    stopCatapush() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isAndroid)
                return this.plugin.stopCatapush();
            this.throwNotImplementedError();
        });
    }
    dispatchCallNotification() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isAndroid)
                return this.plugin.dispatchCallNotification();
            this.throwNotImplementedError();
        });
    }
    pauseOneSignalInAppMessages(options) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isAndroid)
                return this.plugin.pauseOneSignalInAppMessages(options);
            this.throwNotImplementedError();
        });
    }
    addOneSignalTrigger(options) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isAndroid)
                return this.plugin.addOneSignalTrigger(options);
            this.throwNotImplementedError();
        });
    }
    addOneSignalExternalId(options) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isAndroid)
                return this.plugin.addOneSignalExternalId(options);
            this.throwNotImplementedError();
        });
    }
    playRingtone(options) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isAndroid)
                return this.plugin.playRingtone(options);
            this.throwNotImplementedError();
        });
    }
    stopRingtone() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isAndroid)
                return this.plugin.stopRingtone();
            this.throwNotImplementedError();
        });
    }
    unregisterForRemoteIOSNotifications() {
        return __awaiter(this, void 0, void 0, function* () {
            if (Capacitor.platform === "ios")
                return this.plugin.unregisterForRemoteIOSNotifications();
            this.throwNotImplementedError();
        });
    }
    generateKeyPair() {
        return __awaiter(this, void 0, void 0, function* () {
            if (Capacitor.isNative)
                return this.plugin.generateKeyPair();
            return generateKeyPair();
        });
    }
    generateSecretKey() {
        return __awaiter(this, void 0, void 0, function* () {
            if (Capacitor.isNative)
                return this.plugin.generateSecretKey();
            return generateSecretKey();
        });
    }
    generateSecureIV() {
        return __awaiter(this, void 0, void 0, function* () {
            if (Capacitor.isNative)
                return this.plugin.generateSecureIV();
            return generateSecureIV();
        });
    }
    encryptKey(options) {
        return __awaiter(this, void 0, void 0, function* () {
            if (Capacitor.isNative)
                return this.plugin.encryptKey(options);
            return encryptKey(options);
        });
    }
    decryptKey(options) {
        return __awaiter(this, void 0, void 0, function* () {
            if (Capacitor.isNative)
                return this.plugin.decryptKey(options);
            return decryptKey(options);
        });
    }
    encryptMessage(options) {
        return __awaiter(this, void 0, void 0, function* () {
            if (Capacitor.isNative)
                return this.plugin.encryptMessage(options);
            return encryptMessage(options);
        });
    }
    decryptMessage(options) {
        return __awaiter(this, void 0, void 0, function* () {
            if (Capacitor.isNative)
                return this.plugin.decryptMessage(options);
            return decryptMessage(options);
        });
    }
    generateSHA256(options) {
        return __awaiter(this, void 0, void 0, function* () {
            if (Capacitor.isNative)
                return this.plugin.generateSHA256(options);
            return generateSHA256(options);
        });
    }
}
const webPlugin = new Media4CarePluginWeb();
export { webPlugin as Media4CarePlugin };
import { registerWebPlugin } from "@capacitor/core";
registerWebPlugin(webPlugin);
//# sourceMappingURL=web.js.map